import React, { Component } from 'react'
import styled from 'styled-components'
import './styles/hamburguer-settings.scss'

const StyledHamburguer = styled.div`
	> * {
		outline: none;
	}
`

/**
 *
 * @param onClick {function} The event that will called when the user clicks on icon
 * @param isOpen {bool} Defines the current state of icon
 */
class Hamburguer extends Component {
	constructor(props) {
		super(props)
	}

	shouldComponentUpdate(nextProps) {
		return this.props.isOpen !== nextProps.isOpen
	}

	render() {
		const { onClick, isOpen } = this.props
		return (
			<StyledHamburguer>
				<button
					className={`hamburger hamburger--elastic ${
						isOpen ? 'is-active' : ''
					} `}
					type="button"
					onClick={onClick}>
					<span className="hamburger-box">
						<span className="hamburger-inner" />
					</span>
				</button>
			</StyledHamburguer>
		)
	}
}

export default Hamburguer
